import { render, staticRenderFns } from "./Inheritance.vue?vue&type=template&id=586df4fe"
import script from "./Inheritance.vue?vue&type=script&lang=js"
export * from "./Inheritance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports